export enum POST_ACTION {
    CREATE = "CREATE", 
    FETCH_ALL = "FETCH_ALL",
    FETCH_POST = "FETCH_POST", 
    FETCH_BY_SEARCH = "FETCH_BY_SEARCH",
    UPDATE = "UPDATE", 
    LIKE = "LIKE", 
    DELETE = "DELETE",
    START_LOADING = "START_LOADING",
    END_LOADING = "END_LOADING"

}

export enum PROJECT_ACTION {
    CREATE = "CREATE_PROJECT", 
    FETCH_ALL = "FETCH_ALL_PROJECTS",
    FETCH_PROJECT = "FETCH_PROJECT", 
    FETCH_BY_SEARCH = "FETCH_PROJECT_BY_SEARCH",
    UPDATE = "UPDATE_PROJECT", 
    LIKE = "LIKE_PROJECT", 
    DELETE = "DELETE_PROJECT",
    START_LOADING = "START_LOADING_PROJECT",
    END_LOADING = "END_LOADING_PROJECT",
    COLAB = "COLAB_PROJECT"

}

export enum EVENT_ACTION {
    CREATE = "CREATE_EVENT", 
    FETCH_ALL = "FETCH_ALL_EVENTS",
    FETCH_EVENT = "FETCH_EVENT", 
    FETCH_BY_SEARCH = "FETCH_EVENT_BY_SEARCH",
    UPDATE = "UPDATE_EVENT", 
    LIKE = "LIKE_EVENT", 
    DELETE = "DELETE_EVENT",
    START_LOADING = "START_LOADING_EVENT",
    END_LOADING = "END_LOADING_EVENT"

}

export enum AUTH_ACTION {
    AUTH = "AUTH", 
    LOGOUT = "LOGOUT",
    START_LOADING = "START_LOADING",
    END_LOADING = "END_LOADING",
    ERROR = "ERROR",
    SIGNUP_ERROR = "SIGNUP_ERROR",
    END_ERROR = "END_ERROR",
}

// let date =new Date();
export interface PostData {
    _id?: string;
    // creator: string,
    title: string,
    message: string,
    tags: string[],
    selectedFile: string,
    name?: string,
    creator?: String,
    likeCount:string[],
    createdAt?: Date
}

export interface ProjectData {
    _id?: string;
    // creator: string,
    title: string,
    message: string,
    tags: string[],
    selectedFile: string,
    imageUpdated?: Boolean,
    imageUrl?: string,
    members?: string,
    name?: string,
    creator?: string,
    likeCount:string[],
    createdAt?: Date,
    approved?:Boolean,
    finished?:Boolean,
    actionRequired?:Boolean,
    purpose?:string,
    goal?:string,
    resources?:string,
    description?:string,
    status?:string,
    
}

export interface EventData {
    _id?: string;
    // creator: string,
    title: string,
    message: string,
    tags: string[],
    selectedFile: string,
    members?: string,
    name?: string,
    creator?: String,
    likeCount:string[],
    createdAt?: Date,
    approved?:Boolean,
    finished?:Boolean,
    actionRequired?:Boolean,
}

export interface FormData {
    firstName:string,
    lastName: string,
    spellFirstName: string,
    spellLastName: string,
    email: string,
    userID: string,
    profilePic: string,
    password: string,
    confirmPassword:string,
    userType:string,
    companyName:string
}

export interface ColabFormData {
    name: string,
    company: string,
    email: string,
    project_name: string,
    message: string
}

export interface SearchFormat {
    search: string,
    tags: string
}

